import { useFormik } from 'formik';
import { getBookKeys } from "../bookFields";
import { generateInitialValues, generateValidationSchema } from '../../../components/Inputs/formik/utils';
import { loadAsyncOptions, updateBook, uploadBook } from "../bookUtils";
import FormikInput from '../../../components/Inputs/formik/FormikInput';
import { Button, Col, Form, Row, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

/**
 * Creates a form with all the fields required by book. In case 'updateBook' is true,
 * the field 'initialValues' should be specified.
 * @param {{updateBook: boolean, bookRaw: json, lang: json}} props 
 * @returns 
 */
export default function CreateBookForm(props) {
  const fields = getBookKeys(props.lang);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: generateInitialValues(fields, props.bookRaw == undefined ? {} : props.bookRaw),
    validationSchema: generateValidationSchema(fields, props.lang),
    onSubmit: values => { return; }
  })

  const createFields = () => {
    let components = [];
    let queue = [];
    let cont = 0;
    for (let key in fields) {
      let field = <Col md>
        <FormikInput
        formik={formik}
        fieldName={key}
        jsonField={fields[key]}
        loadAsyncOptions={loadAsyncOptions}
        lang={props.lang}
      /> </Col>

      queue.push(field);
      cont++;

      if (cont % 2 == 0) {
        components.push(
          <Row md>
            {queue}
          </Row>
        );
        queue = [];
      }
    }

    if (queue.length != 0) {
      components.push(
        <Row md>
          {queue}
        </Row>
      );
    }

    return components;
  }

  /**
   * Determina si hay errores en el formulario de formik.
   */
  const markErrors = async () => {
    const [resp] = await Promise.all([formik.validateForm()]);

    const promises = [];
    for (var key in formik.values) {
      promises.push(formik.setFieldTouched(key, true));
    }

    const responses = await Promise.all(promises);
    return resp;
  }

  /**
   * Se maneja la validación de datos y se despliega en una notificación retroalimentación
   * sobre el éxito o fallo de la validación de los campos. En caso de éxito, se ingresarán
   * los datos a la base de datos.
   * @param {*} e 
   */
  const handleOwnSubmit = async (e) => {
    const errors = await markErrors();

    if (Object.keys(errors).length === 0) {
      if (props.updateBook) {
        const success = updateBook(formik.values, props.lang);
        if (success) navigate(`/books/${formik.values.title}/details`);
      }
      else uploadBook(formik.values, props.lang);
    } else {
      toast.error(props.lang.book.error.fields_with_errors, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'foo-bar'
      })
    }
  }

  // console.log("props ", props)
  return (
    <>
      <Form noValidate>
        <Card style={{ width: "100%", padding: "10px" }}>
          <Card.Body>
            {createFields()}
            <Button onClick={handleOwnSubmit}>
              {props.updateBook ? props.lang.book.update : props.lang.book.create}
            </Button>
          </Card.Body>
        </Card>
      </Form>
    </>
  )
}